function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Metrc'))  {
    return [
    {
      title: 'METRC',
      icon: 'mdi-shield-outline',
      items: [
        {
          icon: 'mdi-shield-key-outline',
          title: "Licenses",
          path: '/MetrcLicense'
        },
        {
          icon: 'mdi-package',
          title: 'Packages',
          path: '/MetrcPackages'
        },
        {
          icon: 'mdi-bus-clock',
          title: 'Transfers',
          path: '/MetrcTransfers'
        },
        {
          icon: 'mdi-account-supervisor-circle',
          title: 'Customer Types',
          path: '/MetrcCustomerTypes'
        }, {
          icon: 'mdi-chart-bubble',
          title: 'Transfer States',
          path: '/MetrcXferStates'
        }, {
          icon: 'mdi-ruler',
          title: 'Units',
          path: '/MetrcUnits'
        },
        {
          icon: 'mdi-shape-outline',
          title: 'Item Category',
          path: '/MetrcItemCategory'
        }, {
          icon: 'mdi-alpha-b-circle',
          title: 'Item Brand',
          path: '/MetrcItemBrand'
        }, {
          icon: 'mdi-progress-alert',
          title: 'Lab States',
          path: '/MetrcLabStates'
        }, {
          icon: 'mdi-beaker-outline',
          title: 'Lab Types',
          path: '/MetrcLabTypes'
        }, {
          icon: 'mdi-view-compact-outline',
          title: 'Package Types',
          path: '/MetrcPackageTypes'
        }, {
          icon: 'mdi-tune',
          title: 'Package Adjust',
          path: '/MetrcPackageAdjust'
        },
        {
          icon: 'mdi-plus-box',
          title: 'Additive Types',
          path: '/MetrcAddTypes'
        },
        {
          icon: 'mdi-leaf',
          title: 'Plant Growth',
          path: '/MetrcPlantGrowth'
        },
        {
          icon: 'mdi-select-group',
          title: 'Plant Batch Types',
          path: '/MetrcPlantBatchTypes'
        },
        {
          icon: 'mdi-city',
          title: 'Room Types',
          path: '/MetrcLocationTypes'
        },
        {
          icon: 'mdi-delete-variant',
          title: 'Harvested Waste Types',
          path: '/MetrcHarvestWasteType'
        }, {
          icon: 'mdi-playlist-remove',
          title: 'Waste Reasons',
          path: '/MetrcWasteReasons'
        },
        {
          icon: 'mdi-delete-sweep-outline',
          title: 'Waste Methods',
          path: '/MetrcWasteMethods'
        },
        {
          icon: 'mdi-pot-mix',
          title: 'Waste Mix Material',
          path: '/MetrcWMix'
        }
      ]
    }
  ] } else return []
}

export default buildMenu